import React, { useState } from 'react';
import dayjs from 'dayjs';

const OwnerEventBlock = ({
                             slotTime,
                             slotStatus,
                             bookingInfo,
                             isSelected,
                             serviceDuration = 60,
                             onClick,
                             onCancel
                         }) => {
    const [isHovered, setIsHovered] = useState(false);

    const getEventClass = () => {
        const baseClass = 'owner-event-block';

        switch (slotStatus.type) {
            case 'owner-confirmed':
                return `${baseClass} owner-event-confirmed`;
            case 'owner-pending':
                return `${baseClass} owner-event-pending`;
            case 'locked':
                return `${baseClass} owner-event-locked`;
            case 'confirmed-other':
                return `${baseClass} owner-event-confirmed-other`;
            case 'unavailable':
            case 'past':
                return `${baseClass} owner-event-unavailable`;
            case 'free':
                return `${baseClass} ${isSelected ? 'owner-event-free-selected' : 'owner-event-free'}`;
            default:
                return baseClass;
        }
    };

    const getEventTitle = () => {
        switch (slotStatus.type) {
            case 'owner-confirmed':
                return 'Potwierdzony';
            case 'owner-pending':
                return 'Oczekuje';
            case 'locked':
                return 'Zablokowane';
            case 'confirmed-other':
                return 'Zajęte';
            case 'unavailable':
            case 'past':
                return 'Niedostępne';
            case 'free':
                return 'Wolny termin';
            default:
                return '';
        }
    };

    const formatTimeRange = () => {
        const startTime = dayjs(slotTime);
        const endTime = startTime.add(serviceDuration, 'minute');
        return `${startTime.format('HH:mm')} - ${endTime.format('HH:mm')}`;
    };

    const formatDuration = () => {
        if (serviceDuration === 60) return '1h';
        if (serviceDuration < 60) return `${serviceDuration}min`;
        const hours = Math.floor(serviceDuration / 60);
        const minutes = serviceDuration % 60;
        if (minutes === 0) return `${hours}h`;
        return `${hours}h ${minutes}min`;
    };

    const handleClick = (e) => {
        e.stopPropagation();

        if (slotStatus.type === 'free' && onClick) {
            onClick(slotTime);
        }
    };

    const handleCancelClick = (e) => {
        e.stopPropagation();
        if (onCancel && slotStatus.booking) {
            onCancel(slotStatus.booking);
        }
    };

    const isClickable = slotStatus.type === 'free' && slotStatus.canBook;
    const showTimeRange = serviceDuration !== 60;

    return (
        <div
            className={getEventClass()}
            onClick={handleClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                cursor: isClickable ? 'pointer' : 'default',
                opacity: slotStatus.type === 'past' ? 0.6 : 1,
            }}
        >
            <div className="owner-event-title">{getEventTitle()}</div>
            <div className="owner-event-time">
                {showTimeRange ? formatTimeRange() : dayjs(slotTime).format('HH:mm')}
            </div>

            {showTimeRange && (
                <div className="owner-event-duration">
                    ({formatDuration()})
                </div>
            )}

            {slotStatus.type === 'free' && bookingInfo && bookingInfo.bookingCount > 0 && (
                <div className="owner-event-subtitle">
                    Oczekujące: {bookingInfo.bookingCount}
                </div>
            )}

            {slotStatus.booking?.serviceName && (
                <div className="owner-event-subtitle">
                    {slotStatus.booking.serviceName}
                </div>
            )}

            {isHovered &&
                (slotStatus.type === 'owner-confirmed' || slotStatus.type === 'owner-pending') &&
                slotStatus.canCancel &&
                onCancel && (
                    <div className="owner-event-actions">
                        <button
                            className="owner-action-btn"
                            onClick={handleCancelClick}
                            title="Anuluj"
                        >
                            ✕
                        </button>
                    </div>
                )}

            {slotStatus.type === 'free' && isSelected && (
                <div className="owner-event-selected-indicator">
                    ✓
                </div>
            )}
        </div>
    );
};

export default OwnerEventBlock;